"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
exports.useCache = useCache;
const react_1 = require("react");
const CacheContext = (0, react_1.createContext)([
    {
        topLevelSections: [],
        _query: {},
        _fetchTopLevelSections: () => { },
    },
    () => { },
]);
exports.Provider = CacheContext.Provider;
function useCache(key) {
    const cacheContext = (0, react_1.useContext)(CacheContext);
    if (key === undefined) {
        return cacheContext;
    }
    return cacheContext[0][key];
}
